import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { IconButton } from '@mui/material';
import { SetStateAction, useCallback, useEffect, useState } from 'react';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';

// import Tips from './Tips';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { updateOtr } from 'APIs/HotAuctionApi';
import { useAppSelector } from 'app/hooks';
import { socket } from 'app/socket';
import { selectAuth } from 'features/auth/authSlice';
import { addLike, selectOtr } from 'features/auth/otrSlice';
import {
  CreateNotification,
  NotificationType,
} from 'interfaces/Notification.interface';
import { OtrData } from 'interfaces/OtrData.interface';
import { useDispatch } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import OtrVideo from './OtrVideo';
import DownloadMenu from 'components/organisms/VideoCard/Menu';
import { selectNft } from 'features/auth/nftSlice';

interface IPlayerProps {
  otrIndex: number;
  setOtrIndex: SetStateAction<any>;
  fade: boolean;
  setFade: SetStateAction<any>;
  otr: OtrData;
}

type ExitFullscreen = typeof document.exitFullscreen;
type RequestFullscreen = typeof document.documentElement.requestFullscreen;

declare global {
  interface Document {
    webkitExitFullscreen: ExitFullscreen;
    mozCancelFullScreen: ExitFullscreen;
    msExitFullscreen: ExitFullscreen;
  }

  interface HTMLElement {
    webkitRequestFullscreen: RequestFullscreen;
    mozRequestFullScreen: RequestFullscreen;
    msRequestFullscreen: RequestFullscreen;
    muted: boolean;
    play: () => void;
    pause: () => void;
    paused: boolean;
    videoHeight: number;
    videoWidth: number;
  }
}

const OtrPlayer = ({
  otrIndex,
  setOtrIndex,
  fade,
  setFade,
  otr,
}: IPlayerProps) => {
  const [liked, setLiked] = useState<boolean>(false);
  const [showComments, setShowComments] = useState<boolean>(false);
  const otrState = useAppSelector(selectOtr);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();

  const calcMod = useCallback((k: number, n: number): number => {
    return ((k % n) + n) % n;
  }, []);

  const nextOtr = () => {
    if (otrState.otrs) {
      setOtrIndex(calcMod(otrIndex + 1, otrState.otrs.length));
      setFade(false);
    }
  };

  const previousOtr = () => {
    if (otrState.otrs) {
      setOtrIndex(calcMod(otrIndex - 1, otrState.otrs.length));
      setFade(false);
    }
  };

  const toggleFullScreen = () => {
    const el = document.getElementById(`full-screenVideo${otrIndex}`);
    if (el)
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      }
  };

  const handlers = useSwipeable({
    trackMouse: true,
    onSwipedUp: nextOtr,
    onSwipedDown: previousOtr,
  });

  useEffect(() => {
    const isScrollUp = (e: any) => {
      const direction = Math.sign(e.deltaY);
      if (direction === -1) previousOtr();
      else nextOtr();
    };
    window.addEventListener('wheel', isScrollUp);
    return () => window.removeEventListener('wheel', isScrollUp);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const prevVideo = document.getElementById(
      `full-screenVideo${otrIndex - 1}`
    );
    const nextVideo = document.getElementById(
      `full-screenVideo${otrIndex + 1}`
    );
    if (nextVideo) nextVideo.muted = true;
    if (prevVideo) prevVideo.muted = true;
    //eslint-disable-next-line
  }, [otrIndex]);

  const toggleMute = () => {
    const video = document.getElementById(`full-screenVideo${otrIndex}`);
    if (video) video.muted = !video.muted;
  };

  const toggleLike = async () => {
    try {
      if (otrState.otrs && authState.id) {
        setLiked(!liked);

        dispatch(addLike({ id: authState.id, currentIndex: otrIndex }));
        await updateOtr({
          id: otrState.otrs[otrIndex].id,
          likes: [authState.id],
        });
        if (socket && otr.id) {
          const likeNotificationOtr: CreateNotification = {
            fromId: authState.id,
            toId: otr.user.id,
            notificationType: NotificationType.LIKE,
            nftId: otr.id,
          };
          socket.emit('notification', likeNotificationOtr);
        }
      }
    } catch (error) {
      console.log(error);
      setLiked(false);
    }
  };

  const video = document.getElementById(`full-screenVideo${otrIndex}`);

  const playVideo = () => {
    if (video) {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  };


  const nftState = useAppSelector(selectNft);





  return (
    <div className="player-main">
      <div
        style={{ transform: `translateY(-${otrIndex * 100}vh)` }}
        className="player-main-container"
        {...handlers}
      >
        {otrState.otrs &&
          otrState.otrs.map((otr: OtrData, index: number) => (
            <OtrVideo
              otr={otr}
              key={index}
              index={index}
              playVideo={playVideo}
              showComments={showComments}
              nextVideo={nextOtr}
            />
          ))}
      </div>
      <div
        style={{ opacity: fade ? 0 : 1, marginTop: '5%' }}
        className="player-container-buttons"
      >
        <div>
          <IconButton
            style={{ backgroundColor: 'transparent' }}
            sx={{
              fontSize: '16px',
              display: 'flex',
              flexDirection: 'column',
              color: 'white',
            }}
            onClick={toggleLike}
          >
            {otrState.otrs ? (
              authState.id &&
              otrState.otrs[otrIndex] &&
              otrState.otrs[otrIndex].likes.includes(authState.id) ? (
                <FavoriteOutlinedIcon
                  sx={{ color: 'white' }}
                  fontSize="large"
                />
              ) : (
                <FavoriteBorderOutlinedIcon
                  sx={{ color: 'white' }}
                  fontSize="large"
                />
              )
            ) : (
              <></>
            )}
            {otrState.otrs && otrState.otrs[otrIndex]
              ? otrState.otrs[otrIndex].likes
                ? otrState.otrs[otrIndex].likes.length
                : 0
              : 0}
          </IconButton>
        </div>
        <div>
          <IconButton>
            <ShareOutlinedIcon sx={{ fontSize: '14px' }} />
          </IconButton>
          <IconButton>
            <AttachMoneyOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton>
            {nftState.nfts && (
              <DownloadMenu
                image={
                  (nftState.nfts[otrIndex] &&
                    nftState.nfts[otrIndex].watermarkSrc) ||
                  (nftState.nfts[otrIndex] &&
                    nftState.nfts[otrIndex].image)
                }
              >
                <MoreHorizOutlinedIcon
                  fontSize="small"
                  style={{ height: '20px' }}
                />
              </DownloadMenu>
            )}
          </IconButton>
          {/* <IconButton>
            {otrState.otrs && (
              <DownloadMenu
                image={
                  (otrState.otrs[otrIndex] &&
                    otrState.otrs[otrIndex].watermarkSrc) ||
                  (otrState.otrs[otrIndex] && otrState.otrs[otrIndex].image)
                }
              >
                <MoreHorizOutlinedIcon
                  fontSize="small"
                  style={{ height: '20px' }}
                />
              </DownloadMenu>
            )}
          </IconButton> */}
        </div>
        <div>
          <IconButton onClick={previousOtr}>
            <ExpandLessIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={nextOtr}>
            <ExpandMoreIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => {
              setShowComments(!showComments);
            }}
            sx={{ margin: '20px 0px', position: 'relative' }}
          >
            <ChatBubbleOutlineIcon fontSize="small" />
            <span
              style={{
                position: 'absolute',
                height: '25px',
                width: '25px',
                borderRadius: '50%',
                backgroundColor: 'white',
                top: '-5px',
                right: '0px',
                fontSize: '12px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'black',
                fontWeight: '600',
              }}
            >
              {otrState.otrs ? otrState.otrs[otrIndex]?.comments?.length : 0}
            </span>
          </IconButton>
          <IconButton onClick={toggleMute}>
            {video ? (
              video.muted ? (
                <VolumeOffIcon fontSize="small" />
              ) : (
                <VolumeUpIcon fontSize="small" />
              )
            ) : (
              <></>
            )}
          </IconButton>
          <IconButton onClick={toggleFullScreen}>
            <OpenInFullIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default OtrPlayer;
